"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HindsightYearType = void 0;
var HindsightYearType;
(function (HindsightYearType) {
    HindsightYearType[HindsightYearType["LY"] = 0] = "LY";
    HindsightYearType[HindsightYearType["LLY"] = 1] = "LLY";
})(HindsightYearType || (exports.HindsightYearType = HindsightYearType = {}));
